import { equals } from './equality.utils';
export const removeIds = (children, removedIds = []) => {
    if (!children)
        return;
    return children
        .map(child => {
        if (Array.isArray(child))
            return removeIds(child, removedIds);
        return removedIds.includes(child) ? undefined : child;
    })
        .filter(child => child);
};
export const cleanComponents = (components, removedIds) => {
    return components
        .map(c => {
        let props = c.props || {};
        props = typeof props === 'string' ? JSON.parse(props) : props;
        let output = c.output || {};
        output = typeof output === 'string' ? JSON.parse(output) : output;
        let children = c.children || [];
        children = typeof children === 'string' ? JSON.parse(children) : children;
        if (removedIds.includes(c.id))
            return;
        if (children) {
            return Object.assign(Object.assign({}, c), { props,
                output, children: removeIds(children, removedIds) });
        }
        return Object.assign(Object.assign({}, c), { props, output });
    })
        .filter(c => c);
};
export const slateChangeMerger = (slate, oldChanges, newChanges) => {
    const { rootComponents = undefined, updatedComponents = [], addedComponents = [], removedComponentIds = [], } = oldChanges;
    const { rootComponents: newRootComponents = undefined, updatedComponents: newUpdatedComponents = [], addedComponents: newAddedComponents = [], removedComponentIds: newRemovedComponentIds = [], } = newChanges;
    const finalUpdatedComponents = updatedComponents;
    const updatedComponentIds = updatedComponents.map(c => c.id);
    const addedComponentIds = addedComponents.map(c => c.id);
    newUpdatedComponents.forEach(c => {
        if (updatedComponentIds.includes(c.id)) {
            const index = updatedComponentIds.indexOf(c.id);
            finalUpdatedComponents[index] = Object.assign(Object.assign({}, finalUpdatedComponents[index]), c);
        }
        else if (addedComponentIds.includes(c.id)) {
            const index = addedComponentIds.indexOf(c.id);
            addedComponents[index] = Object.assign(Object.assign({}, addedComponents[index]), c);
        }
        else {
            const oldComponent = slate.components[c.id];
            finalUpdatedComponents.push(Object.assign(Object.assign({}, oldComponent), c));
        }
    });
    const removedIds = [...removedComponentIds, ...newRemovedComponentIds];
    const result = {
        rootComponents: removeIds(newRootComponents || rootComponents, removedIds),
        updatedComponents: cleanComponents(finalUpdatedComponents, removedIds),
        addedComponents: cleanComponents([...addedComponents, ...newAddedComponents], removedIds),
        removedComponentIds: removedIds,
    };
    result.rootComponents = equals(result.rootComponents, slate.rootComponents)
        ? undefined
        : result.rootComponents;
    result.updatedComponents = result.updatedComponents.filter(c => !equals(c, slate.components[c.id]));
    result.removedComponentIds = result.removedComponentIds.filter(id => slate.components[id]);
    return result;
};
export const addToArray = (children, newId, afterId) => {
    const afterIdIndex = children.findIndex(child => child === afterId);
    if (afterIdIndex < 0)
        return [newId, ...children];
    return [
        ...children.slice(0, afterIdIndex + 1),
        newId,
        ...children.slice(afterIdIndex + 1),
    ];
};
export const addToChildren = (options) => {
    const { children = [], newId, childId, afterId } = options;
    if (typeof childId === 'number') {
        const updatedChildren = [...children];
        if (updatedChildren.length <= childId) {
            for (let i = updatedChildren.length; i <= childId; i++)
                updatedChildren.push([]);
        }
        if (!Array.isArray(updatedChildren[childId]))
            updatedChildren[childId] = [updatedChildren[childId]];
        updatedChildren[childId] = addToArray(updatedChildren[childId], newId, afterId);
        return updatedChildren;
    }
    return addToArray(children, newId, afterId);
};
export const slateUpdatesIsEmpty = (slateUpdates) => {
    var _a, _b, _c, _d;
    return !(((slateUpdates === null || slateUpdates === void 0 ? void 0 : slateUpdates.addedComponents) &&
        ((_a = slateUpdates === null || slateUpdates === void 0 ? void 0 : slateUpdates.addedComponents) === null || _a === void 0 ? void 0 : _a.length) > 0) ||
        ((slateUpdates === null || slateUpdates === void 0 ? void 0 : slateUpdates.removedComponentIds) &&
            ((_b = slateUpdates === null || slateUpdates === void 0 ? void 0 : slateUpdates.removedComponentIds) === null || _b === void 0 ? void 0 : _b.length) > 0) ||
        ((slateUpdates === null || slateUpdates === void 0 ? void 0 : slateUpdates.rootComponents) &&
            ((_c = slateUpdates === null || slateUpdates === void 0 ? void 0 : slateUpdates.rootComponents) === null || _c === void 0 ? void 0 : _c.length) > 0) ||
        ((slateUpdates === null || slateUpdates === void 0 ? void 0 : slateUpdates.updatedComponents) &&
            ((_d = slateUpdates === null || slateUpdates === void 0 ? void 0 : slateUpdates.updatedComponents) === null || _d === void 0 ? void 0 : _d.length) > 0));
};
//# sourceMappingURL=change-slate.utils.js.map